import { FC } from 'react';
import { LoadingPage } from '@jbc-year-end-adj/2024/components/ui/LoadingPage';

import { useEmployeeQuery as useQuery } from '@jbc-year-end-adj/2024/hooks/graphql/useQuery';

import { ReportList } from './ReportList';
import { FETCH_FINISHED, QueryResult } from './query';
import styles from './EmployeeFinished.scss';

// @ts-ignore
import { Redirect } from 'react-router';

export const EmployeeFinished: FC = () => {
  const { loading, data } = useQuery<QueryResult>(FETCH_FINISHED, {
    fetchPolicy: 'no-cache'
  });

  if (loading) return <LoadingPage />;
  if (!data) throw Error;
  if (!data.request) return <Redirect to="/employee_error?reason=session_expired" />;

  const isWithholdingSlipUnavailable = data.request?.profile?.formerJobs?.some(
    formerJob => formerJob.withholdingSlipStatus === 'unavailable'
  );
  const request = data.request;
  const employee = data.request.employee;
  const requestPrint = data.clientSetting.requestPrint;
  const status = employee.status;

  if (status === 'not_requested') return null;
  const profile = ['in_progress', 'applying', 'rejected', 'fixed'].includes(status) ? request.profile : employee.profile;

  return (
    <div className="l-wrap-xs u-pc-pt100 u-sp-pt20">
      <div className={styles.main}>
        <h2 className={styles.title}>提出が完了しました</h2>
        <h3 className={styles.status}>
          {status === 'accepted' || status === 'not_need_adj' ? (
            <div className={styles.confirmed}>
              管理者から承認されました
              {requestPrint && status === 'accepted' && (
                <p className={styles.confirmedText}>各申告書を印刷し、担当者に提出してください。</p>
              )}
            </div>
          ) : (
            <div className={styles.inprogress}>管理者の承認を待っています</div>
          )}
        </h3>

        {profile && (
          <ReportList
            needAdjThisYear={profile.needAdjThisYear}
            nextYearOnly={profile.nextYearOnly}
            isNotCoveredByNextYear={profile.isNotCoveredByNextYear}
            isWithholdingSlipUnavailable={isWithholdingSlipUnavailable}
          />
        )}

        {status !== 'accepted' && status !== 'not_need_adj' && (
          <ul className="u-mt20">
            <li>・情報提出が完了しました。 情報の修正はできません。</li>
            <li>・情報に誤りがある場合担当者に連絡してください。</li>
          </ul>
        )}
        {status === 'accepted' && (
          <ul className="u-mt20">
            <li>
              <b>・保険等の証明書の原本は提出が必須です。</b>
            </li>
            <li>・添付書類台紙に貼って提出しますと便利です。</li>
          </ul>
        )}
      </div>
    </div>
  );
};
